import React from 'react';
import { DialogActions, DialogContent, Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import FormField from './FormField';
import { Button } from 'catalyst/core';

const DialogForm = ({
    formFields,
    submitText,
    submitForm,
    errors,
    touched,
    values,
    removeSubmit,
    closeDialog,
}) => {
    const submit = (event) => {
        event.preventDefault();
        submitForm();
    };

    return (
        <>
            <DialogContent dividers>
                <form>
                    <Grid container spacing={3}>
                        {formFields.map((field, index) => (
                            <FormField
                                field={field}
                                index={index}
                                errors={errors}
                                touched={touched}
                                values={values}
                            />
                        ))}
                    </Grid>
                </form>
            </DialogContent>
            {!removeSubmit ? (
                <DialogActions>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={closeDialog}
                    >
                        cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        onClick={submit}
                    >
                        {submitText}
                    </Button>
                </DialogActions>
            ) : null}
        </>
    );
};

export default DialogForm;

DialogForm.propTypes = {
    errors: PropTypes.object,
    formFields: PropTypes.array.isRequired,
    formType: PropTypes.string,
    initialValues: PropTypes.object,
    submitForm: PropTypes.func.isRequired,
    submitText: PropTypes.string,
    touched: PropTypes.object,
    values: PropTypes.object,
};

DialogForm.defaultProps = {
    errors: null,
    formFields: null,
    formType: 'standard',
    initialValues: null,
    submitText: 'Submit',
    touched: null,
    values: null,
};
